import {
    Grid,
    Avatar,
    Box,
    Button,
    Dialog,
    Slide,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TextField,
    Tab,
    touchRippleClasses,
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import pr from "../lib/pr";
import axios from "axios";
import { loginState, configState } from "../lib/State";
import get_token from "../lib/get_token";
import HomeCountCash from "./HomeCountCash";
import get_cid from '../lib/get_cid';
import { ReactComponent as PassIcon } from '../assets/pass_back.svg';

function MypageLoggedCouponPass(props) {
    const { login } = props;
    const [rows, setRows] = useState([]);
    const history = useHistory();
    const token = get_token();
    const cid = get_cid();
    // const [count, setCount] = useState('0');

    const onGoBookClick = (event) => {
        history.push("/book?coupon_seq=" + event.target.value);
    };

    const load_data = async () => {
        pr("load_data");
        let result = await axios.post(configState.api + "/gympass/my_coupon_pass", {
            token: token,
            cid: cid,
            mcd: login.mcd,
            level: login.level,
        });
        setRows(result.data.rows);
    };
    useEffect(() => {
        load_data();
        // load_count();
    }, []);

    // const load_count = async () => {
    //     let postData = {
    //         token: token,
    //         mcd: login.mcd,
    //         level: login.level,
    //         cid: configState.cid,
    //       };
    //     let result = await axios.post(configState.api + "/gympass/my_coupon_pass_count", postData);
    //     setCount(result.data.count);
    // };
    // useEffect(() => {
    //     load_count();
    // }, []);
    return (
        <>
            {
                // 쿠폰이 없을 때
                (rows.length === 0) && (
                    <>
                        <Box sx={{ width: "100%", textAlign: "center", fontSize:14 }}>
                            사용 가능한 쿠폰이 없습니다.
                        </Box>
                    </>
                )
            }

            <>
                {/* 쿠폰이 있을 때 */}
                {rows.map((item, index) => {
                    const enroll_sdate = moment(item.enroll_sdate).format('YYYY.MM.DD HH:mm'); // 시작일
                    const enroll_edate = moment(item.enroll_edate).format(
                        "YYYY.MM.DD HH:mm"
                    );

                    return (
                        <Grid
                            container
                            display="flex"
                            width="100%"
                            justifyContent="center"
                            alignItems="center"
                            key={index}
                            // sx={{
                            //     marginBottom: '10px'
                            // }}
                        >
                            <Box
                                sx={{
                                    width: '90%',
                                    position: 'relative',
                                }}>
                                <PassIcon width='100%' />
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        left: '30%',
                                        top: '45%',
                                        transform: 'translateY(-45%)',
                                        marginLeft: '10px',
                                        color: 'white',
                                    }}>
                                    <Box
                                        sx={{
                                            fontSize: '13px',
                                            marginRight: '10px',
                                            fontWeight: 'bold',
                                            letterSpacing: '-1px',
                                        }}>
                                        <Box>
                                            {enroll_sdate} ~ {enroll_edate}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    );
                })}
                <Box sx={{ width: '100%', height: '80px'}}></Box>
            </>
        </>
    )
};

export default MypageLoggedCouponPass;